import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IConfigNotificacion,
  ICreateConfigNotificacion,
  IListado,
  IQueryParam,
  IUpdateConfigNotificacion,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class ConfigNotificacionService {
  constructor(private http: HttpService) {}

  public listar(
    queryParams?: IQueryParam,
  ): Observable<IListado<IConfigNotificacion>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/confignotificacions`, { params });
  }

  public crear(
    dato: ICreateConfigNotificacion,
  ): Observable<IConfigNotificacion> {
    return this.http.post(`${api}/confignotificacions`, dato);
  }

  public listarPorId(id: string): Observable<IConfigNotificacion> {
    return this.http.get(`${api}/confignotificacions/${id}`);
  }

  public editar(
    id: string,
    dato: IUpdateConfigNotificacion,
  ): Observable<IConfigNotificacion> {
    return this.http.put(`${api}/confignotificacions/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/confignotificacions/${id}`);
  }
}
